import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vco from "v-click-outside"

import App from './App.vue'
import router from './router'
import VueFeather from 'vue-feather'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueAlertify from "vue-alertify"
import VueMask from 'v-mask'
import VueQuillEditor from 'vue-quill-editor'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueVectorMap from 'vuevectormap'
import i18n from './i18n'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyEventBus, AmplifyPlugin } from 'aws-amplify-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment-timezone';
import 'boxicons'


import store from '@/state/store'

import { authentication } from './auth'

Vue.config.productionTip = false

import '@/assets/scss/app.scss';
import "@/plugins/vee-validate";
import "@/plugins/vue-multiselect";
import "@/plugins/v-mask";
import "@/plugins/font-awesome";

import 'bootstrap-vue/dist/bootstrap-vue.css'
import "@/plugins/toast";
import ToastPlugin from '@/plugins/toast';
import ToastV2Plugin from '@/plugins/toast-v2'; 

Vue.use(VueSweetalert2);
Vue.use(VueFeather);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(vco)
Vue.component('apexchart', VueApexCharts)
Vue.use(Vuelidate)
Vue.use(VueEasyLightbox)
Vue.use(VueAlertify)
Vue.use(VueMask)
Vue.use(VueQuillEditor)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.use(VueVectorMap)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(ToastPlugin)
Vue.use(ToastV2Plugin)

// Set up amplify config
Amplify.configure({
  Auth: {
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_AWS_USERPOOL_ID,
    identityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AWS_USERPOOL_WEBCLIENT_ID,
    oauth: {
      domain: process.env.VUE_APP_AWS_HOSTED_UI_DOMAIN,
      scope: ['email', 'openid'],
      redirectSignIn: process.env.VUE_APP_AWS_REDIRECT_URI_SIGNIN,
      redirectSignOut: process.env.VUE_APP_AWS_REDIRECT_URI_SIGNOUT,
      responseType: 'code',
    }
  },
  Storage: {
    bucket: process.env.VUE_APP_S3_BUCKET,
    region: process.env.VUE_APP_AWS_REGION,
    identityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID
  }
});

AmplifyEventBus.$on('authState', info => {
  console.log(`Here is the auth event that was just emitted by an Amplify component: ${info}`)
});

Vue.filter('formatDate', function(value) {
  if (value) {
    let dateOptions = {
      day: "numeric", // numeric, 2-digit
      year: "numeric", // numeric, 2-digit
      month: "long", // numeric, 2-digit, long, short, narrow
      hour: "2-digit", // numeric, 2-digit
      minute: "2-digit", // numeric, 2-digit
    };
    let date = new Date(value);

    // console.log(date.toLocaleDateString("en-US", dateOptions));
    if(date.toLocaleDateString("en-US", dateOptions) == "Invalid Date"){
      console.log("return empty", date.toLocaleDateString("en-US", dateOptions));
      return "";
    }else{
      return date.toLocaleDateString("en-US", dateOptions);
    }
  }
});

/* 
  Function: customFormatDate
  Example of Usage:
    Default: 
      {{ data.item.checkpointDate | customFormatDate }} -> convert the utc date to PH timezone with a format of (eg. November 8, 2023 11:46 AM)
    
    Other Example: 
      {{ data.item.checkpointDate | customFormatDate('America/Matamoros', 'YYYY-MM-DD hh:mm:ss') }} -> convert the utc date to America Matamoros with a format of (eg. 2023-03-19 11:46:12)
*/
Vue.filter('customFormatDate', function(value, timezone, format) {
  if (value) {
    return moment.tz(value, 'UTC').tz(timezone || 'Asia/Manila').format(format || 'LLL');
  }
});

Vue.filter('formatDateOnly', function(value) {
  if (value) {
    let dateOptions = {
      day: "numeric", // numeric, 2-digit
      year: "numeric", // numeric, 2-digit
      month: "long", // numeric, 2-digit, long, short, narrow
    };
    let date = new Date(value);

    console.log(date.toLocaleDateString("en-US", dateOptions));
    return date.toLocaleDateString("en-US", dateOptions);
  }
});

Vue.filter('convertTimestamp', function(value) {
    var timestamp = value.toString().length == 13 ? value : value * 1000
    var a = new Date(timestamp);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var sec = a.getSeconds();
    var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    return time;
});

// Created By : Jeffrey I. Ver
// Date Created : May 31, 2022
// Descriptoon no comma on date
Vue.filter('formatDateNoComma', function(value) {
  if (value) {
    var dateOptions = {  
      day: "numeric", // numeric, 2-digit
      year: "numeric", // numeric, 2-digit
      month: "long", // nume };
    }
    var timeOptions = { hour12: true, hour: '2-digit', minute:'2-digit' };
    let date = new Date(value);

    console.log(date.toLocaleDateString("en-US", dateOptions));
    // return date.toLocaleDateString("en-US", timeOptions);
    return date.toLocaleDateString('en', dateOptions) + " " + date.toLocaleTimeString('en', timeOptions);
  }
});

Vue.filter('truncator', function(text = '', length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});
Vue.filter('toCurrency', function (value, currency = '') {
  if (typeof value !== "number") {
      return value;
  }
  if(currency != ''){
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency//'PHP'
    });
    return formatter.format(value);
  }else{
    return value.toFixed(2);
  }
});

Vue.filter('formatKycAccountType', function(value) {
  if (value) {
    let formattedValue = "";

    switch (value) {
        case 'FullyVerified':
            formattedValue = "Fully Verified"
            break;
        case 'FailedKYC':
            formattedValue = "Failed KYC"
            break;
        case 'PendingKYC':
            formattedValue = "Pending KYC"
            break;
        case 'NoKYC':
            formattedValue = "Don't Have KYC"
            break;
        case 'ManualKYC':
            formattedValue = "Manual KYC"
            break;
        default:
            formattedValue = value
            break;
    }

    return formattedValue;
  }
});

Vue.filter('formatKycAccountStatus', function(value) {
  let formattedValue = "";

  if (value) {
    switch (value) {
        case 'Live':
            formattedValue = "Live"
            break;
        case 'Freeze':
            formattedValue = "Freeze"
            break;
        case 'PendingVerification':
            formattedValue = "Pending Verification"
            break;
        case 'FailedVerification':
            formattedValue = "Failed Verification"
            break;
        case 'ManualVerification':
            formattedValue = "Manual Verification"
            break;
        default:
            formattedValue = value
            break;
    }

  }
  else if (value == null || value == "") {
    formattedValue = "--"
  }

  return formattedValue;
});

Vue.filter('numberWithCommas', function (x,decimal=2) {
  try {
    var roundedOf = +(Math.round(x + "e+2")  + "e-2");
    if(isNaN(roundedOf)){
      return '0.00'
    } else if(decimal == 0){
      return roundedOf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
    }else{
      return roundedOf.toFixed(decimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
    }
  } catch (error) {
    console.log(":: numberWithCommas ::", error)
    return x;
  }
});
Vue.filter('notEmpty', function (value, replacer = "--") {
  try {
    var isEmpty = (
      // null or undefined
      (typeof value == "undefined") ||
      (value == undefined) ||
      (value == null) ||
      // has length and it's zero
      (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
      // is an Object and has no keys
      (value.constructor === Object && Object.keys(value).length === 0)
    )
    return isEmpty ? replacer : value
  } catch (error) {
    return value;
  }
});
Vue.filter('readableStoreCategory', function (value) {
  switch (value) {
    case "sss":
      return "Sari Sari Store";
    case "nsss":
      return "Non Sari Sari Store";
    default:
      return "--";
  }
});
Vue.filter('isEmpty', function (value) {//this.$options.filters.isEmpty("");
  try {
    var isEmpty = (
      // null or undefined
      (typeof value == "undefined") ||
      (value == undefined) ||
      (value == null) ||
      // has length and it's zero
      (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
      // is an Object and has no keys
      (value.constructor === Object && Object.keys(value).length === 0)
    )
    return isEmpty
  } catch (error) {
    return false;
  }
});
Vue.filter('addPadding', function(str, padString = '0', targetLength = 7) {
    // Convert the input into a string (in case it's not already a string)
    str = String(str);
    
    // Calculate the number of padding characters needed
    const paddingLength = targetLength - str.length;

    // If the string is already long enough, return it as is
    if (paddingLength <= 0) {
      return str;
    }

    // Repeat the padString as needed and slice it to the required length
    const padding = padString.repeat(Math.ceil(paddingLength / padString.length)).slice(0, paddingLength);

    // Return the padded string by concatenating the padding and original string
    return padding + str;
});
// Cognito callback listener
authentication();
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
